import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import CustomModal from '@/components/CustomModal/CustomModal';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';

interface NewNoteModalProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

const NewNoteModal: FC<NewNoteModalProps> = ({ open, handleClose, onConfirm }) => {
  return (
    <CustomModal open={open} handleClose={handleClose}>
      <Stack gap="1.5rem" alignItems="center" my="30px">
        <Typography variant="h5" fontWeight="600">
          Install NoteGo to start recording
        </Typography>
        <Stack flexDirection="row" gap="1.5rem">
          <Button variant="text" color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm} startIcon={<ExtensionOutlinedIcon />}>
            Install Chrome Extension
          </Button>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default NewNoteModal;
